import React from 'react';
import classes from './FloatingActionBox.module.scss';
import classNames from 'classnames';
import { MediaGridContext } from '../MediaGrid/MediaGrid.view';
import { BreakpointsValuesEnum } from '../../../../constants/breakpoints-values';
import { useBreakpoints } from '../../../../hooks/useBreakpoints';
import { WithChildren } from '../../../../models/children-props';
import { useOnboardingWidgetHeight } from '../../../../hooks/useOnboardingWidgetHeight';

export type FloatingActionBoxViewProps = WithChildren & {
  context: MediaGridContext;
  itemsSelectedCount: number;
};

const floatingActionBoxClasses = classNames('cell align-justify', classes.FloatingActionBox);
const floatingActionBoxContainerClasses = (context: MediaGridContext) =>
  classNames(
    classes.FloatingActionBoxContainer,
    context !== MediaGridContext.PAGE ? classes.FloatingActionBoxContainerModal : null
  );

const FloatingActionBox = (props: FloatingActionBoxViewProps): JSX.Element => {
  const breakpoint: keyof typeof BreakpointsValuesEnum = useBreakpoints();

  const buttonsGroupContainerClasses = classNames({
    'grid-x grid-padding-x': breakpoint !== 'small',
    'grid-y grid-padding-y': breakpoint === 'small',
    [classes.ButtonContainer]: true
  });

  const onboardingWidgetHeight = useOnboardingWidgetHeight();

  return (
    <div className={floatingActionBoxContainerClasses(props.context)}>
      <div className={floatingActionBoxClasses} style={{ marginBottom: onboardingWidgetHeight }}>
        <span className={classes.NumberOfSelectedLabel}>{props.itemsSelectedCount} Media selected</span>
        <div className={buttonsGroupContainerClasses}>{props.children}</div>
      </div>
    </div>
  );
};

export const FloatingActionBoxView = (props: FloatingActionBoxViewProps): JSX.Element => {
  return <FloatingActionBox {...props} />;
};
